var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"px-1"},[_c('v-col',{staticClass:"px-0 py-1",attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":"","color":"bgEmpty","height":"2rem"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }